{
  "APP_NAME": "followup-frontend",
  "About": "A propos",
  "Hello world !": "Bonjour le monde !",
  "Home": "Accueil",
  "Cancel": "Annuler",
  "Change language": "Changer la langue",
  "Language": "Langue",
  "Ok": "Ok",
  "Login": "Connexion",
  "Logout": "Déconnexion",
  "Password": "Mot de passe",
  "Password is required": "Mot de passe requis",
  "Username": "Identifiant",
  "Username is required": "Identifiant requis",
  "Username or password incorrect.": "Identifiant ou mot de passe incorrect.",
  "Remember me": "Rester connecté",
  "Version": "Version"
}
